/**
 * AutoImporting components
 * @param path
 * @returns {function(): *}
 */
const page = path => () =>
    import(/* webpackChunkName: '' */ `./components/${path}`).then(
        m => m.default || m
    );

export const routes = [
    {
        path: "/anticipos",
        name: "Anticipos",
        component: page("AnticipoList")
    },
    {
        path: "/anticipos/:id",
        name: "Show Anticipo",
        component: page("AnticipoView")
    }
];
